import { css } from '@emotion/react';

const tableStyles = css`
    .table-title {
        display: flex;
        align-items: center;

        .collapsible-label,
        .collapsible-icon {
            cursor: pointer;
            margin: 0em 1em;
        }
    }

    .table {
        width: 90%;

        th {
            border-bottom: 1px solid #aeb0b3;
        }

        .hide-row {
            display: none;
        }

        .show-all {
            display: table-row;
        }
    }
`;

export const themetableStyles = css`
    color: var(--default-text-color);

    .table-title {
        display: flex;
        align-items: center;
        font-family: var(--font-family-regular);
        color: var(--default-text-color);
        font-weight: var(--font-weight-regular);
        font-size: var(--font-size-regular);

        .collapsible-label,
        .collapsible-icon {
            cursor: pointer;
            margin: 0em 1em;
        }

        .collapsible-label {
            font-family: var(--font-family-regular);
            color: var(--default-text-color);
            font-weight: var(--font-weight-regular);
            font-size: var(--font-size-xxx-small);
        }

        .collapsible-icon {
            color: var(--default-text-color);
        }
    }

    .table {
        width: var(--tableComponent-tableWidth);

        th {
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            font-family: var(--tableComponent-thFontFamily);
            color: var(--tableComponent-thTextColor);
            font-weight: var(--tableComponent-thFontWeight);
            font-size: var(--tableComponent-thFontSize);
            line-height: var(--tableComponent-thLineHeight);
            padding: var(--tableComponent-thPadding);
        }

        td {
            border-style: var(--tableComponent-tdBorderStyle);
            border-color: var(--tableComponent-tdBorderColor);
            border-width: var(--tableComponent-tdBorderWidth);
            font-family: var(--tableComponent-tdFontFamily);
            color: var(--tableComponent-tdTextColor);
            font-weight: var(--tableComponent-tdFontWeight);
            font-size: var(--tableComponent-tdFontSize);
            line-height: var(--tableComponent-tdLineHeight);
            padding: var(--tableComponent-tdPadding);
        }

        tbody {
            tr:nth-child(odd) {
                background-color: var(--tableComponent-alternatedRowsBGColor);
            }
        }

        tr:last-child {
            td {
                border: none;
            }
        }

        .hide-row {
            display: none;
        }

        .show-all {
            display: table-row;
        }

        .link-icon {
            margin-right: 0.5em;
        }
    }
`;

export default tableStyles;
